export const COOKIE_KEYS = {
  SESSION_TOKEN: 'token'
};

export const LOCAL_STORAGE_KEYS = {};

export const SESSION_STORAGE_KEY = {};
